export default {
    url: '/overview',
    template: '<reports-overview/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/overview/index.js